<template>
    <div class="modal fade" id="addSettingsModal" tabindex="-1" role="dialog" aria-labelledby="addSettingsModalLabel">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
                <!--<div class="modal-header">-->
                <!--<h4 class="modal-title">{{title}}</h4>-->
                <!--</div>-->
                <div class="modal-body">
                    <div class="row" v-if="tableType == 1">
                        <input class="modal-input" type="text" placeholder="DOMAIN NAME"
                               id="add-settings-domain-name-input" v-model="domainName"
                               style="text-transform: lowercase;"/>
                    </div>
                    <div class="row" v-if="tableType == 2">
                        <input class="modal-input" type="text" placeholder="START IP" id="add-settings-start-ip-input"
                               v-model="startIp"/>
                        <hr>
                        <input class="modal-input" type="text" placeholder="END IP" id="add-settings-end-ip-input"
                               v-model="endIp"/>
                    </div>
                    <div class="row" v-if="tableType == 3">
                        <input class="modal-input" type="text" placeholder="BRAND NAME"
                               id="add-settings-brand-name-input" v-model="brandName"
                               style="text-transform: lowercase;"/>
                    </div>
                    <div class="row" v-if="tableType == 7">
                        <input class="modal-input" type="text" placeholder="ENTER LICENSE KEY"
                               id="add-settings-license-key-input" v-model="licenseKey"/>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="modal-footer-container">
                        <button class="modal-button modal-red-button" @click="cancelClicked">CANCEL</button>
                        <button class="modal-button modal-green-button" @click="saveClicked"
                                id="add-settings-save-button" :disabled="isAddButtonDisabled">SAVE
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "add-settings-modal",
        props: {
            tableType: {
                type: Number
            }
        },
        data() {
            return {
                domainName: null,
                startIp: null,
                endIp: null,
                brandName: null,
                licenseKey: null,
                isAddButtonDisabled: false
            }
        },
        methods: {
            showModal() {
                $('#addSettingsModal').modal('show');
            },
            hideModal() {
                $('#addSettingsModal').modal('hide');
            },
            saveClicked() {
                this.isAddButtonDisabled = true;
                this.$emit("saveClicked", {
                    tableType: this.tableType,
                    domainName: this.domainName,
                    startIp: this.startIp,
                    endIp: this.endIp,
                    brandName: this.brandName,
                    licenseKey: this.licenseKey
                })
            },
            cancelClicked() {
                $(".settings-input").val("");
                $('#addSettingsModal').modal('hide');
            },
            clearAndHideModal() {
                $(".settings-input").val("");
                $('#addSettingsModal').modal('hide');
            }
        },
        computed: {
            title() {
                if (this.tableType == 1)
                    return "ADD DOMAIN";
                else if (this.tableType == 2)
                    return "ADD IP";
                else if (this.tableType == 3) {
                    return "ADD BRAND";
                } else if (this.tableType == 7) {
                    return "ADD LICENSE KEY";
                }
            }
        },
        watch: {
            domainName: function () {
                this.isAddButtonDisabled = false;
            },
            startIp: function () {
                this.isAddButtonDisabled = false;
            },
            endIp: function () {
                this.isAddButtonDisabled = false;
            },
            brandName: function () {
                this.isAddButtonDisabled = false;
            },
            licenseKey: function () {
                this.isAddButtonDisabled = false;
            }
        },
        mounted() {
            $('#addSettingsModal').modal({show: false});
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/AddSettingsModal.vue